import { inject, Injectable } from '@angular/core';
import type { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import type { Observable } from 'rxjs';

import { WidgetsService } from 'components/organisms/widgets-loader/widgets.service';
import { HTTP_ERROR_HANDLER_SERVICE } from 'src/services/http-error-handler/entities/const';
import type { IHttpErrorHandlerService } from 'src/services/http-error-handler/entities/types';

import { LayoutService } from '../layouts/services/layout.service';

@Injectable()
export class NotFoundResolverService {
    private readonly httpErrorHandlerService = inject<IHttpErrorHandlerService>(HTTP_ERROR_HANDLER_SERVICE);
    private readonly layoutService = inject(LayoutService);
    private readonly widgetsService = inject(WidgetsService);

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.httpErrorHandlerService.setHttpStatus(404);
        this.widgetsService.markNoWidgets();
        return true;
    }
}
